import { createFileRoute } from "@tanstack/react-router";
import { cecosQueryOptions, clavesSatQueryOptions, cuentasQueryOptions } from "@/features/catalogos/hooks/use-catalogos";
import { ProrrateoMultiplePage } from "@/features/prorrateo-multiple/components/ProrrateoMultiplePage";
import { prorrateosQueryOptions } from "@/features/prorrateo-multiple/hooks/use-prorrateos";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/prorrateo-multiple")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    Promise.all([
      queryClient.ensureQueryData(solicitudQueryOptions(id)),
      queryClient.ensureQueryData(prorrateosQueryOptions(id)),
      queryClient.ensureQueryData(cecosQueryOptions),
      queryClient.ensureQueryData(cuentasQueryOptions),
      queryClient.ensureQueryData(clavesSatQueryOptions),
    ]),
  component: ProrrateoMultiplePage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
